import React from 'react'
import { Card } from './style'

const ToolsGuideCard = ({ description, children }) => (
  <Card key={description}>
    <div className="tools-guide">{children}</div>
    <p className="tools-guide-sub-description">{description}</p>
  </Card>
)

export default ToolsGuideCard
